import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getLang } from "./shared/tools";
import csTranslation from "./locales/cs/translation.json";
import daTranslation from "./locales/da/translation.json";
import deTranslation from "./locales/de/translation.json";
import enTranslation from "./locales/en/translation.json";
import esTranslation from "./locales/es/translation.json";
import fiTranslation from "./locales/fi/translation.json";
import frTranslation from "./locales/fr/translation.json";
import itTranslation from "./locales/it/translation.json";
import nlTranslation from "./locales/nl/translation.json";
import noTranslation from "./locales/no/translation.json";
import plTranslation from "./locales/pl/translation.json";
import ptTranslation from "./locales/pt/translation.json";
import svTranslation from "./locales/sv/translation.json";
import ukTranslation from "./locales/uk/translation.json";
import * as moment from "moment/moment.js";
import "moment/locale/cs";
import "moment/locale/da";
import "moment/locale/de";
import "moment/locale/en-gb";
import "moment/locale/es";
import "moment/locale/fi";
import "moment/locale/fr";
import "moment/locale/it";
import "moment/locale/nb"; // Norwegian Boksmal
import "moment/locale/nl";
import "moment/locale/pl";
import "moment/locale/pt";
import "moment/locale/sv";
import "moment/locale/uk";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  cs: { translation: csTranslation },
  da: { translation: daTranslation },
  de: { translation: deTranslation },
  en: { translation: enTranslation },
  es: { translation: esTranslation },
  fi: { translation: fiTranslation },
  fr: { translation: frTranslation },
  it: { translation: itTranslation },
  nl: { translation: nlTranslation },
  no: { translation: noTranslation },
  nb: { translation: noTranslation }, // Norwegian Boksmal
  pl: { translation: plTranslation },
  pt: { translation: ptTranslation },
  sv: { translation: svTranslation },
  uk: { translation: ukTranslation },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

// Custom detector
let wpmlCurrentLanguage = getLang();
i18n.changeLanguage(wpmlCurrentLanguage);

// Setup locale for moment
moment.locale("en-gb");
if (wpmlCurrentLanguage !== "" && wpmlCurrentLanguage !== "en") {
  moment.locale(wpmlCurrentLanguage);
}

export default i18n;
